import ApiClient from './ApiClient';

class AssistentAPI extends ApiClient {
  constructor() {
    super('assistents', { accountScoped: true });
  }

  getByVersion(version) {
    return axios.get(`${this.url}?version=${version}`);
  }

  uploadFileToOpenAI(file, assistentName = null, vectorStoreId = null) {
    const formData = new FormData();
    formData.append('file', file);
    if(assistentName){
      formData.append('assistent_name', assistentName);
    }
    if(vectorStoreId){
      formData.append('vector_store_id', vectorStoreId);
    }    
    return axios.post(`${this.url}/upload_file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteFile(openaiFileId, blobSignedId) {
    return axios.delete(`${this.url}/delete_file`, {
      data: {
        openai_file_id: openaiFileId,
        blob_signed_id: blobSignedId,
      },
    });
  }

  deleteVectorStore(vectorStoreId) {
    return axios.delete(`${this.url}/delete_file`, {
      data: {        
        vector_store_id: vectorStoreId        
      },
    });
  }
}

export default new AssistentAPI();
